import { Component, ViewChild, ElementRef, Input, Output, EventEmitter, OnInit, HostListener } from '@angular/core';
import { Catalog, Social } from './catalog.service';
import { CockehsuCatalogComponent } from './cockehsu-catalog.component';
import { environment } from '../environments/environment';
import * as d3 from 'd3';

@Component({
  selector: 'cockehsu-drawer',
  templateUrl: 'cockehsu-drawer.component.html',
  styleUrls: ['cockehsu-drawer.component.css'],
})
export class CockehsuDrawerComponent implements OnInit {

  @Input()
  public catalog: Catalog;

  @Input()
  public pdfURL: string;

  @Input()
  public social: Social;

  @ViewChild('slideshow')
  public slideshow: CockehsuCatalogComponent;

  @Output() private zoomAdjust = new EventEmitter<number>();
  @Output() private navAdjust = new EventEmitter<number>();
  @Output() private helpOpen = new EventEmitter<boolean>();
  @Output() private drawerOpen = new EventEmitter<boolean>();
  @Output() private slideshowPageClick = new EventEmitter<number>();

  private host;

  private handleHeight: number;
  private viewportHeight: number;

  constructor(private erHost: ElementRef) {
    this.viewportHeight = 300;
  }

  private _isOpen: boolean = false;

  public get isOpen(): boolean {
    return this._isOpen;
  }

  ngOnInit() {
    this.host = d3.select(this.erHost.nativeElement);
  }

  public open(v: boolean, pageIndex: number) {
    this._isOpen = v;
    if (isNaN(this.handleHeight) || this.handleHeight === 0) {
      this.handleHeight = this.host.select('div.handle').node().clientHeight;
      this.host.select('div.drawer').style('height', `${this.viewportHeight}px`);
    }

    this.host.select('div.handle')
      .transition()
      .on('start', () => {
	this.host.select('div.handle').style('display', 'table');
      })
      .on('end', () => {
        if (v) {
          this.host.select('div.handle').style('display', 'hidden');
        }
      })
      .duration(150)
      .style('opacity', v ? 0 : 1);


    let y = 0;
    if (v) {
      y = -(this.viewportHeight + this.handleHeight);
    }

    this.host.select('div.drawer')
      .transition()
      .on('start', () => {
	this.host.select('div.drawer').style('display', 'table');
      })
      .on('end', () => {
	if (v) {
	  if (this.slideshowNeedsRedraw) {
	    this.slideshow.redraw();
	    this.slideshowNeedsRedraw = false;
	  }
	  if (!isNaN(pageIndex)) {
	    this.slideshow.moveToPage(pageIndex);
	  }
	} else {
	  this.host.select('div.drawer').style('display', 'none');
	}
      })
      .duration(150)
      .style('opacity', v ? 1 : 0)
      .style('transform', `translate(0, ${y}px)`);
  }

  private slideshowNeedsRedraw: boolean = true;

  @HostListener('window:resize', ['$event'])
  private onResize(event: Event) {
    if (this._isOpen) {
      this.slideshow.redraw();
    }
  }

  private onSlideshowPageClick(pageIndex: number) {
    this.slideshowPageClick.emit(pageIndex);
  }

}



// WEBPACK FOOTER //
// ./src/app/cockehsu-drawer.component.ts